var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedback-read-component pa-4"},[_c('h4',{staticClass:"accent--text"},[_vm._v(_vm._s(_vm.title))]),_c('ul',_vm._l((_vm.points),function(point,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(point)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }